export const menuCrossHover = () => {
  let menuTimeout;

  if (window.tc_vars.env_channel === 'desktop') {
    $('.menu-item').hover(function hoverItem() {
      $('.menu-item').removeClass('hovered');
      if ($(this).hasClass('deploy')) {
        $(this).addClass('hovered');
      }
      const tipo = $(this).data('type');
      $('.sub-menu-cross').removeClass('active');
      $(`.sub-menu-cross[data-type=${tipo}]`).addClass('active');
    });
    $('.menu-item.deploy').hover(function hoverMenu() {
      clearTimeout(menuTimeout);
      $(this).parent().removeClass('equipment');
      $(this).parent().removeClass('deportes');
      $(this).parent().removeClass('mujer');
      $(this).parent().removeClass('junior');
      $(this).parent().removeClass('hombre');
      $(this).parent().removeClass('opeco');
      $(this).parent().removeClass('servicios');
      const menuItem = $(this);
      if (!menuItem.parent().hasClass('deployed') && window.tc_vars.env_channel === 'desktop') {
        menuTimeout = setTimeout(() => {
          focusMenuCross();
          menuItem.parent().addClass('deployed');
          if (menuItem.data('type') === 'equipamiento') {
            menuItem.parent().addClass('equipment');
          }
          if (menuItem.data('type') === 'deportes') {
            menuItem.parent().addClass('deportes');
            setTimeout(fixMenuCrossSports, 500);
          }
          if (menuItem.data('type') === 'mujer') {
            menuItem.parent().addClass('mujer');
          }
          if (menuItem.data('type') === 'junior') {
            menuItem.parent().addClass('junior');
          }
          if (menuItem.data('type') === 'hombre') {
            menuItem.parent().addClass('hombre');
          }
          if (menuItem.data('type') === 'fin-de-temporada') {
            menuItem.parent().addClass('fin-de-temporada');
          }
          if (menuItem.data('type') === 'opeco') {
            menuItem.parent().addClass('opeco');
          }
          if (menuItem.data('type') === 'servicios') {
            menuItem.parent().addClass('servicios');
          }

        }, 200);
      } else {
        focusMenuCross();
        menuItem.parent().addClass('deployed');
        if (menuItem.data('type') === 'equipamiento') {
          menuItem.parent().addClass('equipment');
        }
        if (menuItem.data('type') === 'deportes') {
          menuItem.parent().addClass('deportes');
          setTimeout(fixMenuCrossSports, 500);
        }
        if (menuItem.data('type') === 'mujer') {
          menuItem.parent().addClass('mujer');
        }
        if (menuItem.data('type') === 'junior') {
          menuItem.parent().addClass('junior');
        }
        if (menuItem.data('type') === 'hombre') {
          menuItem.parent().addClass('hombre');
        }
        if (menuItem.data('type') === 'fin-de-temporada') {
          menuItem.parent().addClass('fin-de-temporada');
        }
        if (menuItem.data('type') === 'opeco') {
          menuItem.parent().addClass('opeco');
        }
        if (menuItem.data('type') === 'servicios') {
          menuItem.parent().addClass('servicios');
        }
      }
      setAutoHeight();
    });
    $('.menu-item.deploy').mouseleave(() => {
      clearTimeout(menuTimeout);
    });
    $('.not-deploy').hover(function hoverNotDeploy() {
      removeFocus();
      $('.menu-item').removeClass('hovered');
      $(this).parent().removeClass('equipment');
      $(this).parent().removeClass('deployed');
      jQuery('html').removeClass('noscroll');
      $(this).parent().removeClass('deportes');
      $(this).parent().removeClass('mujer');
      $(this).parent().removeClass('junior');
      $(this).parent().removeClass('hombre');
      $(this).parent().removeClass('fin-de-temporada');
      $(this).parent().removeClass('opeco');
      $(this).parent().removeClass('servicios');
      initHeight();
    });
    $('.menu-cross').hover(() => { }, function hoverCross() {
      clearInterval(menuTimeout);
      removeFocus();
      $('.menu-item').removeClass('hovered');
      $(this).removeClass('deployed');
      jQuery('html').removeClass('noscroll');
      $(this).removeClass('equipment');
      $(this).removeClass('deportes');
      $(this).removeClass('mujer');
      $(this).removeClass('junior');
      $(this).removeClass('hombre');
      $(this).removeClass('fin-de-temporada');
      $(this).removeClass('opeco');
      $(this).removeClass('servicios');
      initHeight();
    });
  } else {
    let itemActive = $('.menu-item.hovered').data('type');
    $('.menu-item').on('click', function clickItem() {
      const tipo = $(this).data('type');
      $('.menu-item').removeClass('hovered');
      $(this).addClass('hovered');
      $('.sub-menu-cross').removeClass('active');
      $(`.sub-menu-cross[data-type=${tipo}]`).addClass('active');
    });
    $('.menu-item.deploy').on('click', function clickDeployed() {
      $(this).removeClass('not-hovered');
      if ((itemActive === $(this).data('type')) && ($(this).parent().hasClass('deployed'))) {

        setTimeout(removeFocus, 250);
        $(this).parent().removeClass('equipment');
        $(this).parent().removeClass('deportes');
        $(this).parent().removeClass('mujer');
        $(this).parent().removeClass('junior');
        $(this).parent().removeClass('hombre');
        $(this).parent().removeClass('fin-de-temporada');
        $(this).parent().removeClass('opeco');
        $(this).parent().removeClass('servicios');
        $(this).parent().removeClass('deployed');
        jQuery('html').removeClass('noscroll');
      } else {
        setAutoHeight();
        $(this).parent().addClass('deployed');
        $(this).parent().removeClass('equipment');
        $(this).parent().removeClass('deportes');
        $(this).parent().removeClass('mujer');
        $(this).parent().removeClass('junior');
        $(this).parent().removeClass('hombre');
        $(this).parent().removeClass('fin-de-temporada');
        $(this).parent().removeClass('opeco');
        $(this).parent().removeClass('servicios');
        if ($(this).data('type') === 'equipamiento') {
          $(this).parent().addClass('equipment');
        }
        if ($(this).data('type') === 'deportes') {
          $(this).parent().addClass('deportes');
          setTimeout(fixMenuCrossSports, 500);
        }
        if ($(this).data('type') === 'mujer') {
          $(this).parent().addClass('mujer');
        }
        if ($(this).data('type') === 'junior') {
          $(this).parent().addClass('junior');
        }
        if ($(this).data('type') === 'hombre') {
          $(this).parent().addClass('hombre');
        }
        if ($(this).data('type') === 'fin-de-temporada') {
          $(this).parent().addClass('fin-de-temporada');
        }
        if ($(this).data('type') === 'opeco') {
          $(this).parent().addClass('opeco');
        }
        if ($(this).data('type') === 'servicios') {
          $(this).parent().addClass('servicios');
        }
      }
      itemActive = jQuery(this).data('type');
    });
    jQuery('.not-deploy').on('click', function clickNotDeploy() {
      jQuery(this).parent().removeClass('equipment');
      jQuery(this).parent().removeClass('deployed');
      jQuery('html').removeClass('noscroll');
      jQuery(this).parent().removeClass('deportes');
      jQuery(this).parent().removeClass('mujer');
      jQuery(this).parent().removeClass('junior');
      jQuery(this).parent().removeClass('hombre');
      jQuery(this).parent().removeClass('fin-de-temporada');
      jQuery(this).parent().removeClass('opeco');
      jQuery(this).parent().removeClass('servicios');
    });
    window.addEventListener('click', (e) => {
      if (!document.getElementById('menu-cross').contains(e.target)) {
        $('.menu-cross').removeClass('deployed equipment deportes');
        $('.menu-cross .menu-item').addClass('not-hovered');
      }
    });
  }

  /****** ANALYTICS EVENTS FOR MENU CROSS ******/
  function sendEvent(action, label) {
    cube.analytics.sendEvent(this, '', 'Navigation', action, label);
  }

  /***** ANALYTIC EVENT FOR LINKS IN MENU CROSS *****/
  $('#menu-cross .link__sport__item').on('click', function clickSportsResult() {
    sendEvent('ClickSportsNewMenuMainCategories', `${$(this).parents('.sub-menu-cross').attr('data-type').toUpperCase()}|${$(this).html().toUpperCase()}`);
  });
  $('#menu-cross .content__item').on('click', function clickSportsResult() {
    sendEvent('ClickSportsNewMenuMainCategories', `${$(this).parents('.sub-menu-cross').attr('data-type').toUpperCase()}|${$(this).html().toUpperCase()}`);
  });
  $('#menu-cross .item-category_special').on('click', function clickSportsResult() {
    sendEvent('ClickSportsNewMenuMainCategories', `${$(this).parents('.sub-menu-cross').attr('data-type').toUpperCase()}|ESPECIALES|${$(this).text().toUpperCase()}`);
  });

  /***** ANALYTIC EVENT FOR PRODUCT TYPE OF MENU CROSS *****/
  $('#menu-cross .menucross-imgfaro').on('click', function eventItem() {
    const typeTab=$(this).parents('.sub-menu-cross').attr('data-type');
    const titleTab=$(`.menu-item[data-type=${typeTab}] a`).text();
    sendEvent('ClickSportsNewMenuMainCategories', `${titleTab.toUpperCase()}|${$(this).parents('.column').find('.imgfaro-text a').text().toUpperCase()}`);

  });

  /***** ANALYTIC EVENT FOR LINKS IN SERVICE *****/
  $('#menu-cross .one-service').on('click', function eventContentService() {
    sendEvent('ClickSportsNewMenuMainCategories', `${$(this).find('a').text().toUpperCase()}`);
  });

  /***** ANALYTIC EVENT FOR LINKS IN SERVICE *****/
  $('#menu-cross .menu-item').on('click', function eventItem() {
    sendEvent('ClickSportsNewMenuMainCategories', `${$(this).find('span').text().toUpperCase()}`);
  });

  /*** AUTO HEIGHT ***/
  function setAutoHeight() {
    const height = jQuery('.sub-menu-cross.active').height();
    if (height < 214) {
      jQuery('#menu-cross').height(214+70.7);
    } else {
      jQuery('#menu-cross').height(height+70);
    }
  }

  function initHeight() {
    jQuery('#menu-cross').height(50);
  }

  /*** FOCUS ON MENU CROSS ***/

  function focusMenuCross() {
    $('.background-opacity-body').css('display', 'block');
    $('#menu-cross').css('z-index', 9);
  }

  function removeFocus() {
    $('.background-opacity-body').css('display', 'none');
    $('#menu-cross').css('z-index', 1);
  }

  $(window).resize(() => {
    if (jQuery(window).width() > 800) {
      if (jQuery('#menu-cross').hasClass('deployed')) {
        focusMenuCross();
        fixMenuCrossSports();
      }
    }

  });

  function fixMenuCrossSports() {
    if ((jQuery(window).height() - 100) <= jQuery('#menu-cross').height()) {
      const windowHeight = jQuery(window).height();
      const headerHeight = jQuery('#header').height();
      const menuItemHeight = jQuery('#menu-cross .menu-item').height();
      const newHeight = windowHeight - headerHeight - menuItemHeight;
      jQuery('#all-sport').css({ 'height': `${newHeight - 100}px`, 'overflow-y': 'scroll' });
      jQuery('#menu-cross').css('height', `${newHeight - 30}px`);
      jQuery('html').addClass('noscroll');
    }
  }
};



// WEBPACK FOOTER //
// ./src/_override/shared/menu-cross/functions-menu-cross.js